import React from "react";
import tinymceContent from "tinymce/skins/content/default/content.min.css?inline";
import tinymceOxide from "tinymce/skins/ui/oxide/content.min.css?inline";

export default function TinyMCEpreview({
  html,
  minHeight = 200, // ⭐ 기본값 200px
}) {
  return (
    <div
      className={`rounded-xl bg-white ${
        minHeight ? `min-h-[${minHeight}px]` : ""
      }`}
      style={minHeight ? { minHeight: `${minHeight}px` } : undefined}
    >
      {/* TinyMCE 스타일 */}
      <style>{tinymceContent + "\n" + tinymceOxide}</style>

      {/* 실제 컨텐츠 */}
      <div
        className="prose max-w-none text-gray-800 min-w-0"
        style={{
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
          overflowX: "hidden",
          wordBreak: "break-word",
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}
